import {
	formatValue,
	PRESETS,
	type NumericInput,
} from '@velocity-exchange/common/format';

/**
 * Renders a sub-one value in subscript form, or a seven-plus integer-digit
 * value abbreviated (1M, 1.2B, ...), falling back to the caller's own text
 * when neither applies.
 *
 * `minIntegerDigits` reads the absolute value, so a seven-digit negative (six
 * digits plus the sign) never abbreviates on the sign character alone.
 */
export function formatSpecialValue(
	value: NumericInput,
	fallback: string
): string {
	const formatted = formatValue(value, PRESETS.specialValue);

	return formatted.usedSmallForm || formatted.wasAbbreviated
		? formatted.text
		: fallback;
}
